module.exports = __webpack_public_path__ + "static/media/partner.4944a60e.png";